import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { GuestProvider, useGuest } from './context/GuestContext';
import LoginPage from './pages/LoginPage';
import MainPage from './pages/MainPage';
import BetaPage from './pages/BetaPage';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const { isGuest } = useGuest();
  return (user || isGuest) ? children : <Navigate to="/login" />;
};

const BetaRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" state={{ redirectTo: '/beta' }} />;
};

const AppRoutes = () => {
  const { user } = useAuth();
  const { isGuest } = useGuest();
  return (
    <Routes>
      <Route path="/login" element={(user || isGuest) ? <Navigate to="/" /> : <LoginPage />} />
      <Route path="/" element={
        <ProtectedRoute>
          <MainPage />
        </ProtectedRoute>
      } />
      <Route path="/beta" element={
        <BetaRoute>
          <BetaPage />
        </BetaRoute>
      } />
    </Routes>
  );
};

function App() {
  return (
    <GuestProvider>
      <ThemeProvider>
        <AuthProvider>
          <Router>
            <AppRoutes />
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </GuestProvider>
  );
}

export default App;